module.exports = __webpack_public_path__ + "static/8-2c3fb215adfa91a02ab3df61d0f9ace0.png";